import { render, staticRenderFns } from "./AtomButtonLink.vue?vue&type=template&id=b114a5a6&"
import script from "./AtomButtonLink.vue?vue&type=script&lang=js&"
export * from "./AtomButtonLink.vue?vue&type=script&lang=js&"
import style0 from "./AtomButtonLink.vue?vue&type=style&index=0&id=b114a5a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
